import axios from 'axios';
import {actions as A} from '../constants/actions';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const getTasks = ({
                           taskID = -1,
                           shumaID = -1,
                           taskStatusID = -1,
                           taskTypeID = -1,
                           fromDueDate = '',
                           toDueDate = '',
                           cityID = -1,
                           propertyTypeID = -1,
                           customer = '',
                           requestedPageNumber = 0
                         }) => dispatch => {
  dispatch({
    type: A.GET_TASKS_LIST
  });

  const data = {
    taskID,
    shumaID,
    taskStatusID,
    taskTypeID,
    fromDueDate,
    toDueDate,
    cityID,
    propertyTypeID,
    customer,
    requestedPageNumber
  };

  return axios.post(api.GET_TASKS_LIST, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      const {tasks, totalPageCount, currentPageNumber, totalResultCount} = body;
      dispatch({
        type: A.GET_TASKS_LIST_SUCCESS,
        payload: {list: tasks, totalPages: totalPageCount, totalResultCount},
      });
      dispatch({
        type: A.SET_TASKS_PAGE,
        payload: {page: currentPageNumber}
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_TASKS_LIST_FAILURE,
        payload: err.message
      })
    });
};
